import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import FaIcon from '../../icon/FaIcon/FaIcon';
import styles from './TextAlert.module.scss';

export type TextAlertProps = {
  children?: React.ReactNode;
};

function TextAlert({ children }: TextAlertProps) {
  const currentStyles = styles;

  return (
    <div className={currentStyles.textAlert}>
      <FaIcon icon={faTriangleExclamation} />
      {children}
    </div>
  );
}

export default TextAlert;
